import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { AmazingPanda_1Screen } from "../AmazingPanda/game_1Screen";
    export class AmazingPandaLink_1Screen extends AmazingPanda_1Screen {
        constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
            super(multigameParams, initData, "AmazingPandaLink");
        }
    }
